import wixData from 'wix-data';
import wixWindow from 'wix-window';
import { getItemsConfiguration } from 'public/configuration/mainPageConfiguration.js'
//new
// $w.onReady(async function () {
//     await wixData.query('videoMainPage')
//         .find().then(result => {
//             $w('#videoPlayerMainPage').src = result.items[0].video;
//             //$w('#columnVideo').expand();
//             $w('#videoPlayerMainPage').expand();
//         });
//     const dataset = wixData.query("events").ge('enddate', Date.now()).and(wixData.query("events").eq('onMain', true))
//         .find()
//         .then((results) => {
//             let resultEvent = results.items;
//              wixData.query("university").eq('onMain', true)
//                 .find()
//                 .then((events) => {
//                     let resultUni = events.items
//                     resultEvent = resultEvent.concat(resultUni);
//                 });
//             wixData.query("news").ge('mainPageDate', Date.now())
//                 .find()
//                 .then((events) => {
//                     let resultNews = events.items
//                     $w("#repeaterMainPage").data = (resultEvent.concat(resultNews)).sort(compare);
//                     $w('#repeaterMainPage').expand();
//                 });
//         });
//     const itemsConfiguration = getItemsConfiguration();
//     const postfix = itemsConfiguration['postfix'][wixWindow.multilingual.currentLanguage];
//     $w("#repeaterMainPage").onItemReady(($item, itemData) => {
//         let kategorie = itemsConfiguration.kategorie[itemData.kategorie];
//         if (itemData.isSection) {
//             $item("#imageSqMainPage").link = itemData[kategorie.sectionLink];
//             $item("#imageSqMainPage").src = itemData[kategorie.src[wixWindow.multilingual.currentLanguage]];
//         } else {
//             if (!kategorie)
//                 kategorie = itemsConfiguration.kategorie['DEFAULT'];
//             $item("#imageSqMainPage").src = itemData[kategorie.src[wixWindow.multilingual.currentLanguage]];
//             if (itemData.kategorie === "News") {
//                 const redirect = itemData['toVerticalVersion'];
//                 $item("#imageSqMainPage").link = itemData[kategorie.link[redirect]] + postfix;
//             } else {
//                 $item("#imageSqMainPage").link = itemData[kategorie.link] + postfix;
//             }
//         }
//     })
//     // if (wixWindow.multilingual.currentLanguage === "de") {
//     //     $w('#wixShoutoutWidget2').expand();
//     //     //$w('#footerDatenSchutzDe').expand();
//     //     $w('#wixShoutoutWidget1').collapse();
//     //     //$w('#footerDatenSchutzRU').collapse();
//     // } else {
//     //     $w('#wixShoutoutWidget1').expand();
//     //     //	$w('#footerDatenSchutzRU').expand();
//     //     $w('#wixShoutoutWidget2').collapse();
//     //     //	$w('#footerDatenSchutzDe').collapse();
//     // }
//     //slider
//       const lang = wixWindow.multilingual.currentLanguage === 'de' ? 'de' : 'ru';
//     wixData.query('sliderData').ge("endDate", Date.now()).ascending('priority')
//         .find().then(result => {
//             $w('#galleryMainPage').play();
//             const imagesToShow = [];
//             for (var i = 0; i < result.length; i++) {

//                 const rowInDatabase = result.items[i];
//                 imagesToShow.push({
//                     src: rowInDatabase[itemsConfiguration['slider'][lang]['src']],
//                     link: rowInDatabase["url"],
//                     title: rowInDatabase[itemsConfiguration['slider'][lang]['name']]
//                 });

//             }
//             $w('#galleryMainPage').items = imagesToShow;
//             $w('#galleryMainPage').play();
//         });

// });

// function compare(a, b) {

//     const eventA = a._createdDate;
//     const eventB = b._createdDate;

//     let comparison = 0;
//     if (eventA < eventB) {
//         comparison = 1;
//     } else if (eventA > eventB) {
//         comparison = -1;
//     }
//     return comparison;
// }

//old
$w.onReady(async function () {
   // await wixData.query('videoMainPage')
     //   .find().then(result => {
      //      $w('#videoMainPage').src = result.items[0].video;
      //      $w('#columnVideo').expand();
      //      $w('#videoMainPage').expand();
     //   });
    const dataset = wixData.query("events").eq('isNotVisible', false).and(wixData.query("events").eq('onMain', true))
        .find()
        .then((results) => {
            let resultEvent = results.items;
             wixData.query("university").eq('onMain', true)
                .find()
                .then((events) => {
                    let resultUni = events.items
                    resultEvent = resultEvent.concat(resultUni);
                });
            wixData.query("news").ge('mainPageDate', Date.now()).and(wixData.query("news").eq('onMain', true))
                .find()
                .then((events) => {
                    let resultNews = events.items
                    $w("#repeater1").data = (resultEvent.concat(resultNews)).sort(compare);
                    $w('#repeater1').expand();
                    $w('#columnMainRepeater').expand();
                    //console.log($w("#repeater1").data);
                });
        });
    const itemsConfiguration = getItemsConfiguration();
    const postfix = itemsConfiguration['postfix'][wixWindow.multilingual.currentLanguage];
    $w("#repeater1").onItemReady(($item, itemData) => {
        let kategorie = itemsConfiguration.kategorie[itemData.kategorie];
        $item("#image8").src = itemData[kategorie.src[wixWindow.multilingual.currentLanguage]];
        if (wixWindow.formFactor === "Desktop") {
            $w("#buttonContainer").label = itemsConfiguration['label'][wixWindow.multilingual.currentLanguage];
            if(itemData[kategorie.text[wixWindow.multilingual.currentLanguage]].startsWith("<")){
                if (itemData[kategorie.text[wixWindow.multilingual.currentLanguage]].length>=550) {
                    $item('#textInBox').html = itemData[kategorie.text[wixWindow.multilingual.currentLanguage]].slice(0,550).concat("...</p>");
                }else{
                   $item('#textInBox').html = itemData[kategorie.text[wixWindow.multilingual.currentLanguage]]; 
                }
            }else{
                $item('#textInBox').text = itemData[kategorie.text[wixWindow.multilingual.currentLanguage]].slice(0,550);
            }
            
            //console.log($item('#textInBox').html);
                //$item('#imageSqWhite').link = itemData[config['link']];
        if (itemData.isSection) {
            $item("#image8").link = itemData[kategorie.sectionLink];
            $item('#imageSqWhite').link = itemData[kategorie.sectionLink];
            $item('#buttonContainer').link = itemData[kategorie.sectionLink];
            $item("#image8").src = itemData[kategorie.src[wixWindow.multilingual.currentLanguage]];
            //$item('#textInBox').text.link = itemData[kategorie.src[wixWindow.multilingual.currentLanguage]];
        } else {
            if (!kategorie)
                kategorie = itemsConfiguration.kategorie['DEFAULT'];
            $item("#image8").src = itemData[kategorie.src[wixWindow.multilingual.currentLanguage]];
            if (itemData.kategorie === "News") {
                const redirect = itemData['toVerticalVersion'];
                $item("#image8").link = itemData[kategorie.link[redirect]] + postfix;
                $item('#imageSqWhite').link = itemData[kategorie.link[redirect]] + postfix;
                $item('#buttonContainer').link = itemData[kategorie.link[redirect]] + postfix;
                //$item('#textInBox').text.link = itemData[kategorie.link[redirect]] + postfix;
            } else {
                $item("#image8").link = itemData[kategorie.link] + postfix;
                $item('#imageSqWhite').link = itemData[kategorie.link] + postfix;
                $item('#buttonContainer').link = itemData[kategorie.link] + postfix;
                //$item('#textInBox').text.link = itemData[kategorie.link] + postfix;
            }
            
        }
        } else {
                if (itemData.kategorie === "News") {
                const redirect = itemData['toVerticalVersion'];
                $item("#image8").link = itemData[kategorie.link[redirect]] + postfix;
                $item('#imageSqWhite').link = itemData[kategorie.link[redirect]] + postfix;
                $item('#buttonContainer').link = itemData[kategorie.link[redirect]] + postfix;
                //$item('#textInBox').text.link = itemData[kategorie.link[redirect]] + postfix;
            } else {
                $item("#image8").link = itemData[kategorie.link] + postfix;
                $item('#imageSqWhite').link = itemData[kategorie.link] + postfix;
                $item('#buttonContainer').link = itemData[kategorie.link] + postfix;
               // $item('#textInBox').text.link = itemData[kategorie.link] + postfix;
            }
            }
    })
    if (wixWindow.multilingual.currentLanguage === "de") {
        $w('#wixShoutoutWidget2').expand();
        $w('#wixShoutoutWidget1').collapse();
    } else {
        $w('#wixShoutoutWidget1').expand();
        $w('#wixShoutoutWidget2').collapse();
    }
    //slider
    const lang = wixWindow.multilingual.currentLanguage === 'de' ? 'de' : 'ru';
    wixData.query('sliderData').ge("endDate", Date.now()).ascending('priority')
        .find().then(result => {
            $w('#gallery17').play();
            const imagesToShow = [];
            for (var i = 0; i < result.length; i++) {

                const rowInDatabase = result.items[i];
                imagesToShow.push({
                    src: rowInDatabase[itemsConfiguration['slider'][lang]['src']],
                    link: rowInDatabase["url"],
                    title: rowInDatabase[itemsConfiguration['slider'][lang]['name']]
                });
                $w('#columnStripGallery').expand();
            }
            $w('#gallery17').items = imagesToShow;
            $w('#gallery17').play();
        });

});

function compare(a, b) {

    const eventA = a._createdDate;
    const eventB = b._createdDate;

    let comparison = 0;
    if (eventA < eventB) {
        comparison = 1;
    } else if (eventA > eventB) {
        comparison = -1;
    }
    return comparison;
}

/**
*	Adds an event handler that runs when the mouse pointer is moved
 onto the element.

> **Deprecation note:** The $w parameter of event handlers is being deprecated. To get
 a scoped selector for working with elements in repeater items, use the [$w.at()]($w.html#at) function
 and pass it the context property of the event parameter: `$item = $w.at(event.context)`. To learn more, see
 [here](https://www.wix.com/velo/forum/wix-tips-and-updates/removal-of-the-w-parameter-from-event-handlers).

 You can also [define an event handler using the Properties and Events panel](https://support.wix.com/en/article/velo-reacting-to-user-actions-using-events).
*	 @param {$w.MouseEvent} event
*/
export function container1_mouseIn(event) {
    let factor = wixWindow.formFactor;
    if (wixWindow.formFactor === 'Desktop') {
        let fadeOptions = {
            "duration": 100
        };
       let $item = $w.at(event.context)
       $item('#box2').show("")
    }
}

export function container1_mouseOut(event) {
    let fadeOptions = {
        "duration": 100
    };
    if (wixWindow.formFactor === "Desktop") {
        let $item = $w.at(event.context)
        $item('#box2').hide("")
    }
}